/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import VideoThumbnail from 'react-video-thumbnail';
import fileSize from 'filesize';
import { CHAT_CONSTANTS, dateFormats } from '.';
import { myFirestore, fieldValue } from '../config/firebase';
import DownloadFile from './downloadFile';
import { getMediaRenderTag } from './common';

export const downloadFile = (name, url) => {
  const xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = () => {
    const blob = xhr.response;
    DownloadFile(blob, name);
  };
  xhr.open('GET', url);
  xhr.send();
};

export const getMediaTag = (media) => {
  let mediaSrcTag = '';
  if (media.type.indexOf('image') > -1) {
    mediaSrcTag = (
      <img
        src={media.message}
        alt="media"
        className="image-cover"
      />
    );
  } else if (media.type.indexOf('video') > -1) {
    mediaSrcTag = (
      <VideoThumbnail
        videoUrl={media.message}
      />
    );
  } else {
    mediaSrcTag = (
      <img
        src={getMediaRenderTag({ type: media.type })}
        alt="doc"
      />
    );
  }
  return (
    <p className="modal-post-chat-window">
      {mediaSrcTag}
      <span>
        {media.name}
        <em>{fileSize(media?.size || 0)}</em>
        <button
          className="media-download-btn"
          type="button"
          onClick={() => downloadFile(media.name, media.message)}
        >
          Download
        </button>
      </span>
    </p>
  );
};


export const mapChatData = (userData, messages, isBroadCast = false) => {
  let data = [];
  messages.docs.map((msg) => {
    const msgData = msg.data();
    const messageData = Object.values(msgData).map((el) => el.messages);
    let mappedData = messageData[0].map((el) => {
      el.receiptType = el.senderId === userData._id
        ? CHAT_CONSTANTS.SENT_MESSAGE : CHAT_CONSTANTS.RECEIVED_MESSAGE;
      el.date = moment(el.timestamp).format(dateFormats.MESSAGE_DATE_FORMAT);
      el.time = moment(el.timestamp).format(dateFormats.MESSAGE_TIME_FORMAT);
      return el;
    });
    mappedData = isBroadCast ? mappedData.filter((mpd) => mpd.receiptType === CHAT_CONSTANTS.SENT_MESSAGE && mpd.isBroadCast) : mappedData;
    data = [...data, ...mappedData];
  });
  data = _.uniqBy(data, 'timestamp');
  data.sort((a, b) => a.timestamp - b.timestamp);
  return _.chain(data)
    .groupBy('date')
    .map((value, key) => ({ date: key, messages: value }))
    .value();
};


export const sendMessage = async (senderId, receiverId, message,
  chatRooms, offerId = null, isBroadCast = false, isAdmin = false) => {
  const timestamp = Date.now();
  const conversation = {
    displayMessage: message,
    members: isBroadCast ? [] : [senderId, receiverId],
    lastMessage: timestamp,
    isBroadCast,
    messages: fieldValue.arrayUnion({
      senderId,
      receiverId,
      isAdmin,
      timestamp,
      isBroadCast,
      message,
    }),
  };

  const messageUserData = {
    receiverId,
    senderId,
    unseenMessage: true,
    unseenMessageCount: 0,
    offerId,
    timestamp,
  };
  if (!isBroadCast) {
    await myFirestore.collection(CHAT_CONSTANTS.MESSAGE_BOARD).doc(chatRooms[0]._id)
      .set({ [chatRooms[0]._id]: conversation }, { merge: true });
    messageUserData.receiverId = receiverId;
    messageUserData.conversationId = chatRooms[0]._id;
    myFirestore.collection(CHAT_CONSTANTS.USERS)
      .doc(receiverId).set({ [chatRooms[0]._id]: messageUserData }, { merge: true });
    myFirestore.collection(CHAT_CONSTANTS.USERS)
      .doc(senderId).set({ [chatRooms[0]._id]: { ...messageUserData, ...{ unseenMessage: false } } }, { merge: true });
  } else {
    for (let i = 0; i < chatRooms.length; i += 1) {
      await myFirestore.collection(CHAT_CONSTANTS.MESSAGE_BOARD).doc(chatRooms[i]._id)
        .set({ [chatRooms[i]._id]: conversation }, { merge: true });
      messageUserData.receiverId = receiverId[i];
      messageUserData.conversationId = chatRooms[i]._id;
      myFirestore.collection(CHAT_CONSTANTS.USERS)
        .doc(receiverId[i]).set({ [chatRooms[i]._id]: messageUserData }, { merge: true });
    }
  }
};
